var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 6.66667C19.1667 7.58333 18.4167 8.33333 17.5 8.33333C17.35 8.33333 17.2083 8.31667 17.075 8.275L14.1083 11.2333C14.15 11.3667 14.1667 11.5167 14.1667 11.6667C14.1667 12.5833 13.4167 13.3333 12.5 13.3333C11.5833 13.3333 10.8333 12.5833 10.8333 11.6667C10.8333 11.5167 10.85 11.3667 10.8917 11.2333L8.76668 9.10833C8.63334 9.15 8.48334 9.16667 8.33334 9.16667C8.18334 9.16667 8.03334 9.15 7.90001 9.10833L4.10834 12.9083C4.15001 13.0417 4.16668 13.1833 4.16668 13.3333C4.16668 14.25 3.41668 15 2.50001 15C1.58334 15 0.833344 14.25 0.833344 13.3333C0.833344 12.4167 1.58334 11.6667 2.50001 11.6667C2.65001 11.6667 2.79168 11.6833 2.92501 11.725L6.72501 7.93333C6.68334 7.8 6.66668 7.65 6.66668 7.5C6.66668 6.58333 7.41668 5.83333 8.33334 5.83333C9.25001 5.83333 10 6.58333 10 7.5C10 7.65 9.98334 7.8 9.94168 7.93333L12.0667 10.0583C12.2 10.0167 12.35 10 12.5 10C12.65 10 12.8 10.0167 12.9333 10.0583L15.8917 7.09167C15.85 6.95833 15.8333 6.81667 15.8333 6.66667C15.8333 5.75 16.5833 5 17.5 5C18.4167 5 19.1667 5.75 19.1667 6.66667Z",
    fill: "#213D69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.e591375722945cb02a0147a7fa54e51d.svg";
export { ForwardRef as ReactComponent };